import { useState } from 'react';
import type { SearchFilters } from '../types';

interface SearchFiltersProps {
  onSearch: (filters: SearchFilters) => void;
}

export default function SearchFiltersComponent({ onSearch }: SearchFiltersProps) {
  const [searchType, setSearchType] = useState<SearchFilters['searchType']>('orderNo');
  const [searchValue, setSearchValue] = useState('');
  const [transactionType, setTransactionType] = useState('');
  const [billMonth, setBillMonth] = useState('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('');
  const [paymentType, setPaymentType] = useState('');

  const handleSearch = () => {
    onSearch({
      searchType,
      searchValue,
      transactionType,
      billMonth,
      startTime,
      endTime,
      paymentMethod,
      paymentType,
    });
  };

  const handleReset = () => {
    setSearchType('orderNo');
    setSearchValue('');
    setTransactionType('');
    setBillMonth('');
    setStartTime('');
    setEndTime('');
    setPaymentMethod('');
    setPaymentType('');
    onSearch({
      searchType: 'orderNo',
      searchValue: '',
      transactionType: '',
      billMonth: '',
      startTime: '',
      endTime: '',
      paymentMethod: '',
      paymentType: '',
    });
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 mb-4">
      <div className="grid grid-cols-4 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">搜索类型</label>
          <select
            value={searchType}
            onChange={(e) => setSearchType(e.target.value as SearchFilters['searchType'])}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 cursor-pointer"
          >
            <option value="orderNo">订单号</option>
            <option value="transactionNo">交易流水号</option>
            <option value="productName">产品名称</option>
            <option value="tenantId">租户ID</option>
            <option value="tenantName">租户名称</option>
            <option value="userId">用户ID</option>
            <option value="userName">用户名称</option>
            <option value="organizationId">组织ID</option>
            <option value="organizationName">组织名称</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">搜索内容</label>
          <input
            type="text"
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder="请输入搜索内容"
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">交易类型</label>
          <select
            value={transactionType}
            onChange={(e) => setTransactionType(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 cursor-pointer"
          >
            <option value="">全部</option>
            <option value="新购">新购</option>
            <option value="续购">续购</option>
            <option value="自动续费">自动续费</option>
            <option value="退订">退订</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">账单月份</label>
          <input
            type="month"
            value={billMonth}
            onChange={(e) => setBillMonth(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          />
        </div>
      </div>

      <div className="grid grid-cols-4 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">消费开始时间</label>
          <input
            type="datetime-local"
            value={startTime}
            onChange={(e) => setStartTime(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">消费结束时间</label>
          <input
            type="datetime-local"
            value={endTime}
            onChange={(e) => setEndTime(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">付费方式</label>
          <select
            value={paymentMethod}
            onChange={(e) => setPaymentMethod(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 cursor-pointer"
          >
            <option value="">全部</option>
            <option value="按需购买">按需购买</option>
            <option value="包年包月">包年包月</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">支付方式</label>
          <select
            value={paymentType}
            onChange={(e) => setPaymentType(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 cursor-pointer"
          >
            <option value="">全部</option>
            <option value="余额">余额</option>
            <option value="积分">积分</option>
            <option value="微信支付">微信支付</option>
            <option value="支付宝支付">支付宝支付</option>
          </select>
        </div>
      </div>

      <div className="flex gap-2">
        <button
          onClick={handleSearch}
          className="px-4 py-2 bg-teal-600 text-white text-sm rounded-md hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-search-line mr-1"></i>
          搜索
        </button>
        <button
          onClick={handleReset}
          className="px-4 py-2 bg-gray-100 text-gray-700 text-sm rounded-md hover:bg-gray-200 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-refresh-line mr-1"></i>
          重置
        </button>
      </div>
    </div>
  );
}
